import { LockedCard } from "@components/virtual-receptionist/sms/components/LockedCard";
import { AccessBehaviorProps } from "../AccessGate.types";

export function FlowMobileLockedBehavior({
    children,
    config,
}: AccessBehaviorProps) {
    return (
        <LockedCard
            isLocked
            message={
                (config?.message as string) ??
                "Activate Flow Mobile to use this feature"
            }
        >
            {children}
        </LockedCard>
    );
}